import React from "react"
import { SearchForm } from "./SearchForm"
import { DesktopMenu } from "./DesktopMenu"
import { Topbar } from "./Topbar"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { TcLogo } from "common/components/TcLogo"

interface MastheadProps {
  noDesktopMenu?: boolean
}

export interface HeaderProps {
  noDesktopMenu?: boolean
  noMasthead?: boolean
  wide?: boolean
}

const Masthead = ({ noDesktopMenu }: MastheadProps) => {
  const t = useTranslations("layout.header")

  return (
    <div className="hidden border-b border-solid border-gray-200 text-center lg:block">
      <div className="hidden font-sans lg:block">
        <header className="bg-masthead pt-5">
          <div className="tc-container container mx-auto">
            <div className="mx-auto flex justify-between">
              <div className="flex flex-col items-start">
                <TcLogo width={350} height={40} />
                <div className="text-2xs mt-1 font-bold text-gray-700">{t("slogan")}</div>
              </div>
              <SearchForm />
            </div>
            {noDesktopMenu ? null : <DesktopMenu />}
          </div>
        </header>
      </div>
    </div>
  )
}

export const Header = ({ noDesktopMenu, noMasthead, wide }: HeaderProps) => {
  return (
    <React.Fragment>
      <Topbar wide={wide} />
      {noMasthead ? null : <Masthead noDesktopMenu={noDesktopMenu} />}
    </React.Fragment>
  )
}
